// KhasPage.js — Container utama Zona KHAS
import React, { useState, useEffect, useCallback } from 'react'
import './khas.css'
import './khas-modal.css'
import './khas-ext.css'
import {
  getSession, logout, gantiPassword,
  canAccess, ROLE_LABEL, updateFirstLogin
} from './khasAuth'
import { pengajuanApi } from './khasApi'

import KhasLogin     from './KhasLogin'
import Toast         from './Toast'
import ConfirmModal  from './ConfirmModal'
import BerandaTab    from './BerandaTab'
import DaftarTab     from './DaftarTab'
import RiwayatTab    from './RiwayatTab'
import PenetapanTab  from './PenetapanTab'
import DirektoriTab  from './DirektoriTab'
import AdminTab      from './AdminTab'

const ALL_TABS = [
  { id:'beranda',   label:'Beranda',        minRole:'kdeks' },
  { id:'daftar',    label:'Pengajuan',       minRole:'kdeks' },
  { id:'riwayat',   label:'Riwayat',         minRole:'kdeks', hideFor:['admin','superadmin'] },
  { id:'penetapan', label:'Penetapan',       minRole:'kdeks' },
  { id:'direktori', label:'Direktori',       minRole:'kdeks' },
  { id:'admin',     label:'Dashboard Admin', minRole:'admin'  },
]

// ← Auto logout setelah 15 menit tidak ada aktivitas
const INACTIVITY_MS = 15 * 60 * 1000

/* ── Ganti Password Modal ────────────────────────────────── */
function GantiPasswordModal({ session, onDone }) {
  const [newPass,     setNewPass]     = useState('')
  const [confirmPass, setConfirmPass] = useState('')
  const [showPass,    setShowPass]    = useState(false)
  const [error,       setError]       = useState('')
  const [loading,     setLoading]     = useState(false)

  const handleSubmit = async e => {
    e.preventDefault(); setError('')
    if (newPass.length < 6)     { setError('Kata sandi minimal 6 karakter.'); return }
    if (newPass !== confirmPass) { setError('Konfirmasi kata sandi tidak cocok.'); return }
    setLoading(true)
    const result = await gantiPassword('', newPass)
    setLoading(false)
    if (!result.ok) { setError(result.msg); return }
    updateFirstLogin(session.id)
    onDone()
  }

  return (
    <div className="khas-first-login-overlay">
      <div className="khas-first-login-box">
        <div className="khas-first-login-header">
          <h2>Selamat datang di Zona KHAS</h2>
          <p>Demi keamanan akun, mohon ganti kata sandi Anda sebelum melanjutkan.</p>
        </div>
        <div className="khas-first-login-body">
          <div className="khas-account-info">
            Login sebagai: <b>{session.nama}</b>
            <span style={{ color:'var(--khas-green-d)', fontWeight:600, marginLeft:8 }}>
              ({ROLE_LABEL(session.role)})
            </span>
          </div>
          {error && (
            <div style={{
              background:'var(--khas-red-l)', border:'1px solid #fecaca',
              borderRadius:10, padding:'10px 16px', marginBottom:18,
              fontSize:14, color:'var(--khas-red)'
            }}>
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <label className="khas-fld">
              <span className="khas-lt">Kata Sandi Baru</span>
              <div className="khas-eye-wrap">
                <input className="khas-input khas-input-pr"
                  type={showPass ? 'text' : 'password'}
                  value={newPass}
                  onChange={e => setNewPass(e.target.value)}
                  placeholder="Minimal 6 karakter" autoFocus />
                <button type="button" className="khas-eye-btn"
                  onClick={() => setShowPass(p => !p)}>
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
                    {showPass
                      ? <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>
                      : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
                    }
                  </svg>
                </button>
              </div>
            </label>
            <label className="khas-fld">
              <span className="khas-lt">Konfirmasi Kata Sandi</span>
              <input className="khas-input"
                type={showPass ? 'text' : 'password'}
                value={confirmPass}
                onChange={e => setConfirmPass(e.target.value)}
                placeholder="Ulangi kata sandi baru" />
            </label>
            <button type="submit" className="khas-btn khas-btn-primary"
              style={{ width:'100%', marginTop:8, height:48, fontSize:16 }}
              disabled={loading}>
              {loading ? 'Menyimpan...' : 'Simpan & Lanjutkan'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

/* ── KhasPage ─────────────────────────────────────────────── */
function KhasPage() {
  const [session,       setSession]       = useState(() => getSession())
  const [activeTab,     setActiveTab]     = useState('beranda')
  const [submissions,   setSubmissions]   = useState([])
  const [loading,       setLoading]       = useState(false)
  const [toast,         setToast]         = useState('')
  const [confirmState,  setConfirmState]  = useState(null)
  const [penetapanData, setPenetapanData] = useState(null)
  const [scrolled,      setScrolled]      = useState(false)

const visibleTabs = ALL_TABS.filter(t => {
  if (!canAccess(session, t.minRole)) return false
  if (t.hideFor && t.hideFor.includes(session.role)) return false
  return true
})
  // Load pengajuan dari API
  const loadPengajuan = useCallback(async () => {
    if (!session) return
    setLoading(true)
    try {
      const data = await pengajuanApi.getAll()
      setSubmissions(data.pengajuan || [])
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }, [session])

  useEffect(() => { loadPengajuan() }, [loadPengajuan])

  // Scroll listener
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    setScrolled(false)
    window.scrollTo({ top: 0 })
  }, [activeTab])

  // ← Auto logout setelah 15 menit tidak ada aktivitas
  useEffect(() => {
    if (!session) return

    let timer

    const resetTimer = () => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        logout()
        setSession(null)
        setActiveTab('beranda')
        setPenetapanData(null)
        setSubmissions([])
        setToast('Sesi berakhir karena tidak ada aktivitas selama 15 menit')
      }, INACTIVITY_MS)
    }

    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart', 'click']
    events.forEach(e => window.addEventListener(e, resetTimer, { passive: true }))
    resetTimer() // mulai timer sejak login

    return () => {
      clearTimeout(timer)
      events.forEach(e => window.removeEventListener(e, resetTimer))
    }
  }, [session])

  const headerHero = activeTab === 'beranda' && !scrolled

  const showToast = msg => { setToast(msg); setTimeout(() => setToast(''), 2600) }

  const handleSubmitSuccess = async () => {
    await loadPengajuan()
    showToast('Pengajuan berhasil dikirim!')
  }

  const goTab = (id, data = null) => {
    if (id === 'penetapan') setPenetapanData(data)
    setActiveTab(id)
  }

  const handleLogout = () => {
    logout()
    setSession(null)
    setActiveTab('beranda')
    setPenetapanData(null)
    setSubmissions([])
  }

  const handleLoginSuccess = sess => {
    setSession(sess)
    loadPengajuan()
    if (!sess.is_first_login) showToast('Selamat datang, ' + sess.nama)
  }

  if (!session) {
    return <KhasLogin onLoginSuccess={handleLoginSuccess} />
  }

  if (session.is_first_login) {
    return (
      <div className="khas-page">
        <GantiPasswordModal session={session} onDone={() => {
          const updated = getSession()
          setSession(updated)
          showToast('Kata sandi berhasil diperbarui!')
        }} />
        <Toast message={toast} />
      </div>
    )
  }

  const safeTab = visibleTabs.find(t => t.id === activeTab) ? activeTab : 'beranda'

  return (
    <div className="khas-page">
      <header className={`khas-header ${headerHero ? 'is-hero' : 'is-solid'}`}>
        <div className="khas-header-inner">
          <div className="khas-logo" onClick={() => goTab('beranda')} style={{ cursor:'pointer' }}>
            <img src="/assets/image/Logo_ZonaKhas.png" alt="Zona KHAS"
              style={{ height:48, width:'auto', objectFit:'contain' }} />
          </div>

          <nav className="khas-tabs">
            {visibleTabs.map(t => (
              <button key={t.id}
                className={'khas-tab' + (safeTab === t.id ? ' active' : '')}
                onClick={() => goTab(t.id)}>
                {t.label}
              </button>
            ))}
          </nav>

          <div className="khas-header-right">
            <div style={{ textAlign:'right' }}>
              <div className="khas-user-name">{session.nama}</div>
              <div className="khas-user-role">
                {ROLE_LABEL(session.role)}
                {session.instansi_pemda && (
                  <span style={{ fontWeight:400, opacity:.7, marginLeft:6 }}>
                    · {session.instansi_pemda}
                  </span>
                )}
              </div>
            </div>
            <button className="khas-btn khas-btn-outline khas-btn-sm"
              onClick={handleLogout} style={{ borderRadius:99 }}>
              Keluar
            </button>
            <a href="/" className="khas-btn khas-btn-outline khas-btn-sm"
              style={{ textDecoration:'none', borderRadius:99 }}>
              ← KNEKS
            </a>
          </div>
        </div>
      </header>

      <main className={safeTab === 'beranda' ? '' : 'khas-main'}>
        {loading && safeTab !== 'beranda' && (
          <div style={{ textAlign:'center', padding:40 }}>
            <div className="loader" />
          </div>
        )}
        {!loading && (
          <>
            {safeTab === 'beranda' && <BerandaTab onGoTab={goTab} />}
            {safeTab === 'daftar'    && <DaftarTab session={session} onSubmitSuccess={handleSubmitSuccess} onToast={showToast} onConfirm={setConfirmState} onGoTab={goTab} />}
            {safeTab === 'riwayat'   && <RiwayatTab session={session} submissions={submissions} onGoTab={goTab} />}
            {safeTab === 'penetapan' && <PenetapanTab session={session} preFillData={penetapanData} submissions={submissions} onToast={showToast} onConfirm={setConfirmState} onGoTab={goTab} />}
            {safeTab === 'direktori' && <DirektoriTab />}
            {safeTab === 'admin'     && canAccess(session, 'admin') && (
              <AdminTab session={session} submissions={submissions} saveSubmissions={loadPengajuan} onToast={showToast} onConfirm={setConfirmState} />
            )}
          </>
        )}
      </main>

      {safeTab !== 'beranda' && (
        <footer className="khas-footer">
          Sistem pendaftaran <b>Zona KHAS</b> &mdash; Zona Kuliner Halal, Aman &amp; Sehat
          &nbsp;&middot;&nbsp; KNEKS 2026
        </footer>
      )}

      <Toast message={toast} />
      <ConfirmModal state={confirmState} onClose={() => setConfirmState(null)} />
    </div>
  )
}

export default KhasPage